<template>
  <div>
    <!-- 
       ************************************************ 顶部菜单************************************************
    -->
    <transition name="program-head" appear>
      <div v-if="programToggle" class="program-change-information-head">
        <div style="display: flex; align-items: center">
          <div class="story-name">
            {{ itemTreeData.title }}
          </div>
          <el-dropdown
            trigger="click"
            style="padding-left: 10px"
            v-if="posCode != 'guest'"
          >
            <span class="el-dropdown-link">
              <i class="las la-ellipsis-v"> </i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="editTitleAndDialog"
                v-if="!$store.state.isPresentationMode"
                >编辑</el-dropdown-item
              >
              <el-dropdown-item
                v-if="!$store.state.isPresentationMode"
                @click.native="changePresentationModeStateMethod"
                >演示模式</el-dropdown-item
              >
              <el-dropdown-item v-else @click.native="backtrack"
                >退出演示</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="op-area">
          <el-menu
            v-if="elMenuData"
            ref="elMenu"
            :default-active="programActiveIndex"
            :unique-opened="true"
            text-color="#ccc"
            active-text-color="#fff"
            menu-trigger="click"
            mode="horizontal"
            class="program-el-menu"
            popper-class="isFuck"
          >
            <template v-for="(item, key) in elMenuData">
              <el-menu-item
                :key="key"
                :index="`${key}`"
                v-if="item.children == null || item.children.length == 0"
              >
                <div class="menu-item" @click="childmodal(item)">
                  <i :class="item.meta.icon"></i>{{ item.meta.title }}
                </div>
              </el-menu-item>
              <el-submenu
                v-else
                :key="key"
                :index="`${key}`"
                popper-class="program-submenu"
              >
                <template slot="title">
                  <div class="menu-item">
                    <i :class="item.meta.icon"></i>{{ item.meta.title }}
                  </div>
                </template>
                <template v-for="(i, x) in item.children">
                  <el-menu-item
                    :key="x"
                    :index="`${key}-${x}`"
                    @click="childmodal(i)"
                    ><i :class="i.meta.icon"></i>
                    {{ i.meta.title }}</el-menu-item
                  >
                </template>
              </el-submenu>
            </template>
          </el-menu>
        </div>

        <div class="sys-area op-area">
          <toolLibrary
            v-if="toolLibraryData && Object.keys(toolLibraryData).length > 0"
            :toolLibraryData="toolLibraryData"
            :hierarchy="modalIf"
            @videoSurveilBox_close="basicSettingsShow = false"
            ref="toolLibrary"
          ></toolLibrary>
          <el-menu
            v-if="
              rElMenuData.length > 0 && Object.keys(toolLibraryData).length > 0
            "
            ref="elMenu"
            :default-active="programActiveIndex"
            :unique-opened="true"
            text-color="#ccc"
            active-text-color="#fff"
            menu-trigger="click"
            mode="horizontal"
            class="program-el-menu"
            popper-class="isFuck"
          >
            <template
              v-for="(item, key) in rElMenuData"
              v-if="item.remark != 'toolLibrary'"
            >
              <!-- {{ item.remark }} -->
              <el-menu-item
                :key="key"
                :index="`${key}`"
                v-if="item.children == null || item.children.length == 0"
              >
                <div class="menu-item" @click="childRmodal(item)">
                  <i :class="item.meta.icon"></i>{{ item.meta.title }}
                </div>
              </el-menu-item>
              <el-submenu
                v-else
                :key="key"
                :index="`${key}`"
                popper-class="program-submenu"
              >
                <template slot="title">
                  <div class="menu-item">
                    <i :class="item.meta.icon"></i>{{ item.meta.title }}
                  </div>
                </template>
                <template v-for="(i, x) in item.children">
                  <el-menu-item
                    :key="x"
                    :index="`${key}-${x}`"
                    @click="childRmodal(i)"
                    ><i :class="i.meta.icon"></i>
                    {{ i.meta.title }}</el-menu-item
                  >
                </template>
              </el-submenu>
            </template>
          </el-menu>
          <!-- <div
            class="menu-item"
            @click="
              childmodal({
                remark: 'modelSet',
              })
            "
          >
            <i class="las la-tree"></i>辅助模型
          </div> -->
          <!-- {{ toolLibraryData }} -->

          <el-popover
            placement="bottom"
            trigger="click"
            @show="transparentInit"
            style="height: 100%"
          >
            <el-form
              ref="form"
              label-width="100px"
              style="width: 250px"
              class="transparent_value"
            >
              <el-form-item label="环境显示">
                <el-switch
                  v-model="transparentSwitch"
                  @input="ifTransparent"
                ></el-switch>
              </el-form-item>
              <el-form-item label="环境透明值">
                <el-slider
                  style="width: 80%"
                  :min="0"
                  :max="1"
                  :step="0.1"
                  :disabled="!transparentSwitch"
                  v-model="transparentValue"
                  @input="transparent()"
                >
                </el-slider>
              </el-form-item>
            </el-form>

            <div class="menu-item" slot="reference">
              <i class="las la-cloud-sun"></i>环境控制
            </div>
          </el-popover>

          <div class="menu-item" @click="platformSetting">
            <i class="las la-cog"></i>设置
          </div>

          <!-- </div> -->
          <div class="menu-item" @click="backtrack('return')">
            <i class="el-icon-logout1"></i>
            返回
          </div>
        </div>
      </div>
    </transition>
    <!-- 
       ************************************************ 顶部菜单end************************************************
    -->

    <!-- 
       ************************************************ 左侧菜单************************************************
    -->
    <transition name="program-left-menu" appear>
      <div
        v-if="programToggle"
        class="program-change-information-left-menu"
        :class="{
          'if-left-fold': ifLeftFold,
        }"
      >
        <div style="margin-bottom: 5px" v-if="!$store.state.isPresentationMode">
          <el-input
            class="tree-filter"
            placeholder="请输入关键字"
            clearable
            v-model="filterProgramText"
            @clear="clearProgram"
          >
            <i
              class="el-icon-search el-input__icon"
              slot="suffix"
              @click="filterProgram"
              style="cursor: pointer"
            >
            </i>
          </el-input>
        </div>
        <div class="program-add">
          <el-button
            class="program-button"
            :style="selectedScene ? 'width:85%' : 'width:100%'"
            @click="addGrouping"
            v-if="!$store.state.isPresentationMode"
          >
            <i class="el-icon-folder-add"></i> 添加分组
          </el-button>
          <i
            class="las la-list-alt"
            v-if="!$store.state.isPresentationMode && selectedScene"
            style="
              padding-left: 13px;
              cursor: pointer;
              color: rgb(204, 204, 204);
            "
            @click="openSceneTree"
          ></i>
        </div>
        <el-scrollbar
          :class="{
            isEditTablist: !$store.state.isPresentationMode,
          }"
          style="height: 98%"
        >
          <el-collapse v-model="programActiveNames">
            <el-collapse-item
              v-for="(item, index) in grouping"
              :key="item.id"
              :name="index"
              :data-mode-ui-id="item.id"
              :class="
                filterProgramText == '' &&
                !$store.state.isPresentationMode &&
                (ifEditGroupingtitle == null ||
                  !(ifEditGroupingtitle == `menuTitleInput${index}`))
                  ? 'isCollapseDrop'
                  : 'isCollapseDisabled'
              "
            >
              <template slot="title">
                <div class="program-left-menu-title">
                  <span
                    v-show="
                      ifEditGroupingtitle == null ||
                      !(ifEditGroupingtitle == `menuTitleInput${index}`)
                    "
                  >
                    {{ item.name }}
                  </span>
                  <el-input
                    v-if="ifEditGroupingtitle == `menuTitleInput${index}`"
                    v-model="item.name"
                    :ref="`menuTitleInput${index}`"
                    @keyup.enter.native="$event.target.blur()"
                    @keyup.native="noBubbling"
                    @blur="editGroupingtitle(item)"
                    class="menu-title-input"
                  ></el-input>
                  <!-- @blur="editGroupingtitle(item)" -->
                  <div class="operation-view" @click.stop="">
                    <el-dropdown
                      @command="leftHandleCommand"
                      trigger="click"
                      v-if="!$store.state.isPresentationMode"
                    >
                      <span class="el-dropdown-link">
                        <i class="las la-ellipsis-v"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          :command="{
                            item: item,
                            index: index,
                            type: 'edit',
                          }"
                          >重命名</el-dropdown-item
                        >
                        <el-dropdown-item
                          :command="{
                            item: item,
                            index: index,
                            type: 'copy',
                          }"
                          >复制</el-dropdown-item
                        >
                        <el-dropdown-item
                          :command="{
                            item: item,
                            index: index,
                            type: 'delete',
                          }"
                          >删除</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>

                    <!-- <i
                      class="small-operation-btn el-icon-edit"
                      @click.stop="editGrouping(item, index)"
                    ></i>

                    <i
                      v-if="0"
                      class="small-operation-btn el-icon-delete"
                      @click.stop="deleteGrouping(item, index)"
                    ></i> -->
                  </div>
                </div>
              </template>
              <ul class="program-thumbnail">
                <li
                  v-for="(i, x) in item.scenesData"
                  :key="i.id"
                  @click="thumbnailClick(i, `${index}-${x}`, item)"
                  :data-mode-li-id="i.id"
                  :class="{
                    transition: i.type == 'usually',
                    active: i.id == sceneId,
                    isChildrenDrop:
                      filterProgramText == '' &&
                      !$store.state.isPresentationMode &&
                      (ifSceneReName == null ||
                        !(ifSceneReName == `sceneReNameInput${index}-${x}`)),
                  }"
                >
                  <template v-if="i.type == 'theEssential'">
                    <div
                      class="program-thumbnail-time"
                      style="width: 100%; padding: 0 20px"
                    >
                      <span
                        v-show="
                          ifSceneReName == null ||
                          !(ifSceneReName == `sceneReNameInput${index}-${x}`)
                        "
                      >
                        {{ i.name }}
                      </span>
                      <div
                        @click.stop=""
                        v-if="ifSceneReName == `sceneReNameInput${index}-${x}`"
                      >
                        <el-input
                          v-model="i.name"
                          :ref="`sceneReNameInput${index}-${x}`"
                          class="menu-title-input"
                          @keyup.enter.native="$event.target.blur()"
                          @keyup.native="noBubbling"
                          @blur="editSceneReName(i)"
                        ></el-input>
                      </div>

                      <div
                        v-if="!$store.state.isPresentationMode"
                        class="program-thumbnail-time-operate"
                        @click.stop=""
                      >
                        <i
                          @click.stop="openAction(i, `${index}-${x}`)"
                          class="las la-list-ol"
                        ></i>
                        <!-- <i
                          @click.stop="copyOperation(i, `${index}-${x}`)"
                          class="las la-copy"
                        ></i> -->
                        <el-dropdown
                          @command="leftChildrenHandleCommand"
                          trigger="click"
                        >
                          <span class="el-dropdown-link">
                            <i class="las la-ellipsis-v"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                              :command="{
                                item: i,
                                index: `${index}-${x}`,
                                type: 'rename',
                              }"
                              >重命名</el-dropdown-item
                            >
                            <el-dropdown-item
                              :command="{
                                item: item,
                                index: x,
                                type: 'edit',
                              }"
                              >编辑</el-dropdown-item
                            >
                            <el-dropdown-item
                              :command="{
                                item: i,
                                index: `${index}-${x}`,
                                type: 'copy',
                              }"
                              >复制</el-dropdown-item
                            >
                            <!-- <el-dropdown-item
                              :command="{
                                item: i,
                                index: `${index}-${x}`,
                                type: 'subscenes',
                              }"
                              >创建子场景</el-dropdown-item
                            > -->
                            <el-dropdown-item
                              :command="{
                                item: item,
                                index: x,
                                type: 'delete',
                              }"
                              >删除</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>

                      <!-- <div class="program-thumbnail-time-button">
                        <i
                          @click.stop="editScenes(item, x)"
                          class="small-operation-btn el-icon-edit"
                        ></i>
                        <i
                          @click.stop="deleteScenes(item, x)"
                          class="small-operation-btn el-icon-delete"
                        ></i>
                      </div> -->
                    </div>
                  </template>
                  <template v-else>
                    <el-tree
                      v-if="item.showTransition"
                      :data="[i]"
                      :props="defaultProps"
                      @node-click="handleNodeClick"
                    ></el-tree>
                  </template>
                </li>

                <li class="filter">
                  <el-button
                    class="program-button program-thumbnail-add"
                    @click="addScenes(item)"
                    v-if="!$store.state.isPresentationMode"
                  >
                    <i class="el-icon-plus"></i> 添加场景</el-button
                  >
                </li>
              </ul>
            </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
        <div
          class="fold-operation"
          @click="
            () => {
              this.ifLeftFold = !this.ifLeftFold;
            }
          "
        >
          <i class="el-icon-arrow-left show-i"></i>
        </div>
      </div>
    </transition>
    <!-- 
       ************************************************子场景************************************************
    -->
    <!-- <subscenes></subscenes> -->
    <!-- 
       ************************************************子场景end************************************************
    -->
    <!-- 
       ************************************************ 左侧菜单end ************************************************
    -->
    <!-- 
       ************************************************模态框************************************************
    -->

    <SwitchScenes
      ref="switchScenes"
      v-if="ifSwitchScenes && sceneActive != ''"
      v-model="sceneActive"
      :grouping="grouping"
      :thumbnailClick="thumbnailClick"
      :close="
        () => {
          // 切换下一步时候关闭所有操作
          Object.keys(this.modalIf).forEach((item) => {
            if (item != 'part') {
              this.modalIf[item] = false;
            }
          });
          this.ifScreenplay = false;
          this.scenerResourceClose();
        }
      "
    ></SwitchScenes>
    <!-- 不展示了 -->
    <MapModal
      v-if="!$store.state.isPresentationMode && false"
      title="场景资源树"
      id="scenerResourceTree"
      :modalNode="modalNode2"
      :close="scenerResourceClose"
      :class="{
        'if-left-resources': ifLeftFold,
      }"
    ></MapModal>

    <MapModal
      title="场景图层树"
      id="scenerResourceTree"
      :modalNode="modalNode"
      :close="closeSceneTree"
      :class="{
        'if-left-resources': ifLeftFold,
        'if-left-scenetree': isSceneTreeShow,
      }"
      ref="scenerResource"
    ></MapModal>

    <MapModal
      v-if="modalIf.sceneInformation"
      title="场景信息"
      id="sceneInformationTree"
      :modalNode="modalNodeScenes"
      :submitData="submitPartData"
      :close="sceneInformationClose"
      :submit="onPartSubmit"
    ></MapModal>
    <!--  -->
    <MapModalPart
      ref="MapModalPart"
      v-if="modalIf.part && submitPartData.isAreaShow"
      :contentHtml="submitPartData.content"
      :partStyle="partStyle"
      :class="submitPartData.areaLocation"
      :title="submitPartData.title"
      :ifLeftFold="ifLeftFold"
      :redactScene="modalIf.sceneInformation"
      @stretchModal="stretchModal"
    ></MapModalPart>

    <MapModal
      :modalNode="modalNodeEdit"
      title="编辑"
      id="viewpointTourEdit"
      :close="transitionViewpointClose"
      :submitData="submitViewpointData"
      :submit="onSubmitViewpointt"
    >
    </MapModal>
    <!--  -->
    <PlanDemo v-if="modalIf.pointView" :close="deleteChildmodal"></PlanDemo>
    <!--  -->
    <PlotItem
      v-show="isPlotItemShow"
      :selectedScene="selectedScene"
      :currentNode="currentPlotPidNode"
      @plotItemClose="deleteChildmodal"
      @changeInfoRefreshPlotTree="changeInfoRefreshPlotTree"
      @plotSaveSuccessful="updateScenesTreeNodeList"
      ref="plotItemImg"
    ></PlotItem>
    <PlotTreeScript
      v-show="modalIf.plotItem"
      :selectedScene="selectedScene"
      :modalNodeData="modalNodeData"
      :getSchemeTree="updateScenesTreeNodeList"
      :grouping="grouping"
      @plotItemClose="deleteChildmodal"
      @plotSaveSuccessful="updateScenesTreeNodeList"
      @editPlotEmites="handlePlotEdit($event)"
      ref="poltItemRef"
    >
    </PlotTreeScript>

    <ShpModal
      v-if="bimVector"
      v-show="modalIf.shp"
      :close="deleteChildmodal"
      :getSchemeTree="updateScenesTreeNodeList"
      :selectedScene="selectedScene"
      :modalNodeData="modalNodeData"
      ref="shpModal"
    ></ShpModal>

    <ScenerModel
      v-if="modalIf.model"
      :close="deleteChildmodal"
      :getSchemeTree="updateScenesTreeNodeList"
      :selectedScene="selectedScene"
      :modalNodeData="modalNodeData"
      :postNewTerrainDiggingDat="postNewTerrainDiggingDat"
    ></ScenerModel>

    <mapSwiper
      v-if="showimg"
      :close="
        () => {
          this.showimg = false;
        }
      "
      :imgList="imgList"
      :articleString="articleString"
    ></mapSwiper>

    <mapVideoPlay
      v-if="showVideo"
      :close="
        () => {
          this.showVideo = false;
        }
      "
      :videoList="videoList"
    >
    </mapVideoPlay>

    <!-- 图片上传 -->
    <ImageResources
      v-if="modalIf.imageResources"
      :selectedScene="selectedScene"
      :close="deleteChildmodal"
      :sceneId="sceneId"
      :getSchemeTree="updateScenesTreeNodeList"
    >
    </ImageResources>
    <!-- 操作 -->
    <!-- {{ selectedScene }} -->
    <ScreenplayModel
      v-if="ifScreenplay"
      :selectedScene="selectedScene"
      :resourceTreeCheck="resourceTreeCheck"
      :close="screenplayModelClose"
      ref="screenplayModel"
    >
    </ScreenplayModel>

    <!-- 矢量 -->
    <Vector
      v-if="modalIf.vector"
      :sceneId="sceneId"
      :getSchemeTree="updateScenesTreeNodeList"
    >
    </Vector>

    <!-- <skyBox
      v-if="ifSkyBox"
      :close="
        () => {
          ifSkyBox = false;
        }
      "
    >
    </skyBox> -->

    <!-- 修改标题 -->
    <changeTitleDialog
      v-if="isChangeTitleDialog"
      @closeChangeTitleDialog="isChangeTitleDialog = false"
    ></changeTitleDialog>

    <!-- 资源管理 -->

    <MapModal
      style="z-index: 9999"
      v-if="itemTreeData && itemTreeData.isShow"
      :modalNode="introduceModalNode"
      :title="itemTreeData.title"
      id="introduce"
      :close="
        () => {
          itemTreeData.isShow = false;
        }
      "
    >
      <template slot="content">
        <div class="introduce-content">
          <h2>{{ itemTreeData.title }}</h2>
          <div v-html="itemTreeData.richText"></div>
        </div>
      </template>
    </MapModal>
    <BasicSettings
      v-show="basicSettingsShow"
      :hierarchy="modalIf"
      @basicSettingsBox_close="basicSettingsShow = false"
    >
    </BasicSettings>

    <NewTerrainDigging
      v-if="modalIf.terrain"
      :selectedScene="selectedScene"
      :newTerrainDiggingData="newTerrainDiggingData"
      :getSchemeTree="getSchemeTree"
      :close="deleteChildmodal"
      :modalNodeData="modalNodeData"
      ref="NewTerrainDigging"
    >
    </NewTerrainDigging>

    <!-- 暂时 -->

    <!-- 图片上传 -->
    <!-- <Timeline
      v-if="modalIf.timeline"
      :close="deleteChildmodal"
      :sceneId="sceneId"
      @shutDownLeftDrawer="shutDownLeftDrawer"
    >
    </Timeline> -->

    <!-- 交通模拟 -->
    <trafficSimulation
      v-show="modalIf.trafficSimulation"
      :close="
        () => {
          modalIf.trafficSimulation = false;
        }
      "
    ></trafficSimulation>

    <!-- ptv -->
    <ptv
      v-if="modalIf.ptv"
      :close="
        () => {
          modalIf.ptv = false;
        }
      "
    ></ptv>

    <viewpoint
      v-if="modalIf.viewpoint"
      @plotItemClose="deleteChildmodal"
      ref="viewpoint"
    ></viewpoint>
    <modelSet
      v-if="modalIf.modelSet"
      @plotItem_click="deleteChildmodal"
      ref="modelSet"
    ></modelSet>
    <trafficSimulation_PTV
      v-if="modalIf.trafficSimulation_PTV"
      @plotItem_click="deleteChildmodal"
      :close="
        () => {
          modalIf.trafficSimulation_PTV = false;
        }
      "
      ref="trafficSimulation_PTV"
    ></trafficSimulation_PTV>

    <StationQuery
      v-if="modalIf.stationQuery"
      :close="
        () => {
          modalIf.stationQuery = false;
        }
      "
    >
    </StationQuery>

    <!-- <HundredStake :showHundredStake="modalIf.hundredStake"> </HundredStake> -->
    <NewModelCut
      v-show="modalIf.newModelCut"
      :selectedScene="selectedScene"
      :close="
        () => {
          modalIf.newModelCut = false;
        }
      "
    ></NewModelCut>

    <replicatedDirectory
      v-if="isReplicatedDirectory"
      :replicatedDirectoryProps="replicatedDirectoryProps"
      :close="() => (isReplicatedDirectory = false)"
      @copyGrouping="copyGrouping($event)"
      @copyScene="copyOperation($event)"
      @copySuccess="getSchemeTree"
    ></replicatedDirectory>

    <ConstructionSimulation
      v-show="modalIf.constructionSimulation"
      :sceneId="sceneId"
      :close="
        () => {
          modalIf.constructionSimulation = false;
        }
      "
      :isShow="modalIf.constructionSimulation"
      @initAnimation="initAnimation"
    ></ConstructionSimulation>

    <Animation ref="animation"></Animation>

    <!-- 
       ************************************************模态框end************************************************
    -->
  </div>
</template>
<script>
let pointLayer;
let textLayer;
let graphicLayer = new mars3d.layer.GraphicLayer();
const MapModal = () => import("@/components/common/mapModal/Index");
const MapModalPart = () => import("@/components/common/mapModal/Part");
const PlotItem = () => import("@/components/tables/plotItem/PlotItem.vue");
const PlotTreeScript = () =>
  import("@/components/tables/plotItem/plotTreeScript.vue");
const viewpoint = () => import("@/components/tables/viewpoint/viewpoint.vue");
const modelSet = () => import("@/components/tables/modelSet/modelSet.vue");
const trafficSimulation_PTV = () =>
  import("@/components/tables/fixedRoute/PTV_trafficFlow.vue");
const PlanDemo = () => import("@/components/tables/planDemo/PlanDemo.vue");
const ScenerModel = () => import("./scenerModel/Index.vue");
const mapSwiper = () => import("@/components/common/swiper/Index.vue");
const MapVideoPlay = () => import("@/components/common/mapVideoPlay/Index.vue");
const ShpModal = () => import("@/components/tables/shpInfoList/Index.vue");
const ImageResources = () => import("@/components/tables/resources/Index.vue");
const Vector = () => import("@/components/tables/vector/Vector.vue");
const BasicSettings = () =>
  import("@/components/tables/basicSettings/BasicSettings.vue");
const ScreenplayModel = () =>
  import("@/components/tables/program/screenplay/Index.vue");
const SwitchScenes = () =>
  import("@/components/tables/program/switchScenes/Index.vue");
const NewTerrainDigging = () =>
  import("@/components/tables/newTerrainDigging/Index.vue");
// const Timeline = () => import("@/components/tables/Timeline/Timeline.vue");
const changeTitleDialog = () => import("./changeTitleDialog");
const trafficSimulation = () =>
  import("@/components/tables/fixedRoute/Index.vue");
const toolLibrary = () => import("@/components/common/menu/ToolLibrary");
const ptv = () => import("@/components/tables/ptv/Index.vue");
const subscenes = () => import("@/components/tables/subscenes/Index.vue");
const StationQuery = () => import("@/components/tables/stationQuery/Index.vue");
const HundredStake = () => import("@/components/tables/hundredStake/Index.vue");
const NewModelCut = () => import("@/components/tables/newModelCut/Index.vue");
const replicatedDirectory = () =>
  import("@/components/tables/replicatedDirectory/index.vue");
// const skyBox = () => import("@/components/common/skyBox/Index.vue");
const ConstructionSimulation = () =>
  import("@/components/tables/animation/constructionSimulation/List.vue");
const Animation = () => import("@/components/tables/animation/Index.vue");

import { elMenuData2, screenplayData } from "./static-data";
import * as mapWork from "@/components/tables/program/map.js";
import * as mapWorkDyeing from "./scenerModel/map.js";
import * as mapWorkAnimation from "@/components/tables/animation/map.js";
import * as plotOperation from "@/components/tables/plotItem/plotConfig.js";
import * as mapCompare from "@/components/tables/compare/map.js";
import * as modelCut from "@/components/tables/newModelCut/map.js";

import Screenplay from "./screenplay.js";
import Sortable from "sortablejs";

import _ from "lodash";
import {
  addBimPlanGrouping,
  deleteBimPlanGrouping,
  copyBimPlanGrouping,
  editBimPlanGrouping,
  editBimPlanSceneName,
  treeNodeList,
  getScenesTreeNodeList,
  addBimPlanScenes,
  deleteBimPlanScenes,
  editBimPlanScenes,
  deteleBimPlottedData,
  getBimPlanScenesMethodList,
  postBimPlanScenesEditSort,
  postBimPlanGroupingEditSort,
  getProjectBimModel,
  copyPlanScenes,
  getDLdinooprstw,
  dropDownList,
  getDropDownGroupingList,
  getBimPlanScenesDetail,
  menuChange,
  getBimPlanList,
  // getModelPropertyList,
  getBimPlanAllGrouping,
  getDropDownList,
  getKmlDropDownList,
  getShpInfoDropDownList,
  getBimPlanPaintingDropDownList,
  getDropDownTreeList,
  detailBimConstructSimGrouping,
} from "@/api/api";
import screenplayFn from "./screenplayFn";

export default {
  name: "program-change-information",
  components: {
    MapModal,
    MapModalPart,
    PlanDemo,
    ScenerModel,
    ShpModal,
    PlotItem,
    PlotTreeScript,
    mapSwiper,
    MapVideoPlay,
    ImageResources,
    Vector,
    BasicSettings,
    ScreenplayModel,
    SwitchScenes,
    NewTerrainDigging,
    changeTitleDialog,
    toolLibrary,
    trafficSimulation,
    ptv,
    viewpoint,
    subscenes,
    StationQuery,
    HundredStake,
    NewModelCut,
    replicatedDirectory,
    modelSet,
    ConstructionSimulation,
    Animation,
    trafficSimulation_PTV,
    // skyBox,
  },
  props: {
    // itemTreeData 当前树的信息 当编辑的时候才有
    itemTreeData: {
      type: Object,
    },
    // changState 状态 add 或者 edit
    changState: {
      type: String,
    },
    // programToggle 当前值 true 是展示 false 是回退到上级
    programToggle: {
      type: Boolean,
    },
    // 菜单
    menuData: {
      type: Array,
    },
    bimVector: {
      type: Boolean,
    },
  },
  data() {
    return {
      screeningSceneResouece: false,
      resourceOptions: { model: [], kml: [], shp: [], plot: [], pit: [] },
      isSceneTreeShow: false,
      isReplicatedDirectory: false,
      replicatedDirectoryProps: null,
      isChangeTitleDialog: false,
      // 场景id
      sceneId: 0,
      sceneActive: "",
      scenePid: 0,
      plotItemId: null,
      // 顶部菜单数据
      elMenuData: null,
      rElMenuData: [],
      toolLibraryData: {},
      isToolLibrary: true,

      // 右侧菜单数据
      grouping: null,

      ifEditGroupingtitle: null,
      ifSceneReName: null,
      programActiveIndex: "2",
      programActiveNames: [0],
      screenActiveNames: null,
      hoverIndex: -1,
      showimg: false,
      showVideo: false,
      ifLeftFold: false,
      modalIf: {
        sceneInformation: false,
        part: false,
        pointView: false,
        model: false,
        plotItem: false,
        shp: false,
        imageResources: false,
        timeline: false,
        vector: false,
        terrain: false,
        trafficSimulation: false,
        ptv: false,
        viewpoint: false,
        hundredStake: false,
        stationQuery: false,
        newModelCut: false,
        elevationImage: false,
        modelSet: false,
        trafficSimulation_PTV: false,
        constructionSimulation: false,
      },

      ifAnimation: false,
      // scenerResourceShow: false,
      basicSettingsShow: false,
      // 选中场景
      selectedScene: null,

      currentPlotPidNode: null,
      // 选中方案
      selectedPlan: null,
      modalNodeData: null,
      modalNode: {
        scenerResourceTree: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            left: 252,
            // unit: "px", // 默认px
          },
          width: "200px", // 宽度配置 默认450px
          height:
            document.querySelector("#mars3d-container").offsetHeight -
            80 +
            "px", // 配置模态框中心高度
          //模态框head配置
          head: {
            // //是否能拖动
            // canmove: {
            //   //当前拖动状态
            //   state: false,
            // },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "sceneResourcetree", // id和ref使用的同一个
            name: "title", // 树的展示字段 默认name
            i_icon: {
              // level_1: "el-icon-tickets",
            },
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            filterButton: {
              icon: "las la-filter laFilterGrey",
              click: this.screeningShow,
            },
            search: {
              //不需要搜索直接不传
              // type: "", //暂时无用 预留字段 后期配置 判断是否是ajax
              keywords: "title", // 搜素配置关键字 默认是name
              filterNode: this.filterSceneResource, // 搜索的逻辑 可以自己配置
            },
            // nodeClick 事件绑定
            nodeClick: this.nodeClick,
            expandClick: true,

            // 多选框
            // checkeArr: [],
            // checkBox: true,
          },
          //模态框foot配置
        },
      },
      modalNode2: {
        scenerResourceTree: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            left: 252,
            // unit: "px", // 默认px
          },
          width: "200px", // 宽度配置 默认450px
          height:
            document.querySelector("#mars3d-container").offsetHeight -
            80 +
            "px", // 配置模态框中心高度
          //模态框head配置
          head: {
            // //是否能拖动
            // canmove: {
            //   //当前拖动状态
            //   state: false,
            // },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "sceneResourcetree", // id和ref使用的同一个
            name: "text", // 树的展示字段 默认name
            i_icon: {
              // level_1: "el-icon-tickets",
            },
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            search: {
              //不需要搜索直接不传
              // type: "", //暂时无用 预留字段 后期配置 判断是否是ajax
              keywords: "text", // 搜素配置关键字 默认是name
              // filterNode: this.filterNode, // 搜索的逻辑 可以自己配置
            },
            // nodeClick 事件绑定
            expandClick: true,

            // 多选框
            // checkeArr: [],
            // checkBox: true,
          },
          //模态框foot配置
        },
      },
      modalNodeScenes: {
        sceneInformationTree: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -400,
            // unit: "px", // 默认px
          },
          width: "400px", // 宽度配置 默认450px
          // height: `${
          //   document.querySelector("#mars3d-container").offsetHeight - 30
          // }px`, // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          content: {
            type: "form",
            formData: {
              perspective: {
                md: 24,
                type: "button",
                icon: "el-icon-camera",
                buttonTitle: "保存视角",
                click: this.mapImg,
              },
              pId: {
                md: 24,
                type: "select",
                title: "选择分组",
                disabled: false,
                options: [],
              },
              title: {
                md: 24,
                type: "input",
                title: "场景标题",
                placeholder: "请填场景标题",
              },
              isAreaShow: {
                md: 24,
                type: "switch",
                title: "显示简介",
                placeholder: "请填场景标题",
              },
              // width: {
              //   md: 12,
              //   type: "input",
              //   title: "宽度",
              // },
              // height: {
              //   md: 12,
              //   type: "input",
              //   title: "高度",
              // },
              areaLocation: {
                md: 24,
                type: "select",
                title: "简介定位",
                disabled: false,
                options: [
                  {
                    name: "左上",
                    id: "l-t",
                  },
                  {
                    name: "右上",
                    id: "r-t",
                  },
                  {
                    name: "左下",
                    id: "l-b",
                  },
                  {
                    name: "右下",
                    id: "r-b",
                  },
                  {
                    name: "居中",
                    id: "middle",
                  },
                ],
              },
              content: {
                md: 24,
                type: "rich",
                title: "简介内容",
                toolbar:
                  "undo redo | styleselect | bold italic forecolor | lists image table",
              },
            },
          },
          //模态框foot配置
        },
      },
      // 暂存
      showIntroduce: true,
      introduceShow: true,
      introduceModalNode: {
        introduce: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 5,
            left: 22,
            unit: "%", // 默认px
          },
          width: "60%", // 宽度配置 默认450px
          height: "600px",
          // height: `${
          //   document.querySelector("#mars3d-container").offsetHeight - 30
          // }px`, // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      // 暂存
      submitPartData: {
        id: "",
        pId: "",
        url: null,
        title: "",
        content: "",
        isAreaShow: false,
        areaLocation: "l-t",
        alt: null,
        heading: null,
        lat: null,
        lng: null,
        pitch: null,
        duration: null,
        stop,
        width: "550",
        height: "400",
      },
      lock: true,
      // 展示
      // 定位&&大小
      partStyle: {
        w: "550px",
        h: "400px",
        t: "85px",
        l: "270px",
        bg: "rgba(12,18,30,0.5)",
        ac: "#03e0ff",
      },
      defaultProps: {
        children: "children",
        label: "title",
      },
      // 漫游
      // 场景过渡数量
      sceneKey: -1,
      routeData: [],
      playState: null,
      modalNodeEdit: {
        viewpointTourEdit: {
          show: false, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 70,
            left: 260,
            // unit: "px", // 默认px
          },
          width: "300px", // 宽度配置 默认450px
          height: `370px`, // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          content: {
            type: "form",
            formData: {
              url: {
                md: 24,
                type: "button",
                icon: "el-icon-camera",
                buttonTitle: "截取视角",
                click: this.screenshot,
              },
              text: {
                md: 24,
                type: "input",
                title: "视点标题",
                placeholder: "请填场景标题",
              },
              duration: {
                md: 24,
                type: "input",
                icon: "秒",
                title: "过渡时长",
                placeholder: "请填场景标题",
              },
              stop: {
                md: 24,
                type: "input",
                icon: "秒",
                title: "停留时间",
                placeholder: "请填场景标题",
              },
            },
            rules: {
              alt: [
                {
                  required: true,
                  message: "请保存一个视点",
                  trigger: "blur",
                },
              ],
              text: [
                {
                  required: true,
                  message: "请填写标题",
                  trigger: "blur",
                },
              ],
            },
          },
        },
      },
      submitViewpointData: {
        id: "",
        url: null,
        text: "",
        alt: 0,
        heading: 0,
        lat: 0,
        lng: 0,
        pitch: 0,
        duration: 0,
        stop: 0,
      },
      modalNodeEditItem: null,
      imgList: [],
      videoList: [],
      articleString: null,
      ifScreenplay: false,
      initBimModelArr: [],
      sortableUl: null,
      sortableLi: {},
      // 天空盒子
      // ifSkyBox: false,
      // 环境透明参数
      transparentSwitch: true,
      transparentValue: 1,
      ifSwitchScenes: true,
      isPlotItemShow: false,
      filterProgramText: null,
      newTerrainDiggingData: null,
      posCode: window.sessionStorage.getItem("posCode"),
    };
  },
  methods: {
    handleMouseEnter(index) {
      if (this.$store.state.isPresentationMode) {
        console.log("进入");
        this.hoverIndex = index;
        this.programActiveNames = [index];
      }
    },
    handleMouseLeave(index) {
      if (this.$store.state.isPresentationMode) {
        console.log("离开");
        this.hoverIndex = -1;
        this.programActiveNames = [];
      }
    },
    noBubbling(event) {
      event.stopPropagation();
      event.preventDefault();
    },
    // 演示模式开启
    changePresentationModeStateMethod() {
      // 顶部菜单保留四位
      if (this.elMenuData.length > 0) {
        this.elMenuData = this.elMenuData.slice(0, 4);
      }
      // 开启演示模式
      this.$store.commit("changePresentationModeState", true);
      // 打开全屏
      // document.documentElement.webkitRequestFullscreen();
      // 提示
      this.$notify({
        title: "提示",
        message: "已进入演示模式",
        type: "success",
        duration: 960,
        offset: 320,
      });
    },
    // 打开编辑标题和弹窗的事件
    editTitleAndDialog() {
      this.isChangeTitleDialog = true;
    },
    //  ************************************************左侧菜单
    // 项目概况小图标事件 编辑分组
    leftHandleCommand(command) {
      let { index, item, type } = command;
      switch (type) {
        case "edit":
          this.editGrouping(item, index);
          break;
        case "copy":
          getBimPlanList({
            projectId: sessionStorage.getItem("nowProjectId"),
          }).then((res) => {
            if (res.data.data.length > 1) {
              this.isReplicatedDirectory = false;
              this.replicatedDirectoryProps = {
                type: "grouping",
                groupingItem: res.data.data,
                currentKey: this.$route.params.scenarioGroupId,
                currentGroupingId: item.id,
              };
              this.$nextTick(() => {
                this.isReplicatedDirectory = true;
              });
            } else {
              this.copyGrouping(item, index);
            }
          });
          break;
        case "delete":
          this.$confirm("确认删除？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.deleteGrouping(item, index);
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消",
              });
            });

          break;
      }
    },
    // 场景重命名
    sceneRename(item, index) {
      this.ifSceneReName = `sceneReNameInput${index}`;
      this.$nextTick(function () {
        this.$refs[`sceneReNameInput${index}`][0].focus();
      });
    },
    editSceneReName(data) {
      this.$NProgress.set(0.8).inc(0.2);
      this.ifSceneReName = null;
      editBimPlanSceneName({
        id: data.id,
        name: data.name,
      })
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.getSchemeTree();
            this.$notify({
              title: "编辑场景成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.$NProgress.done(true);
          } else {
            this.$notify({
              title: "编辑场景失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          this.$notify({
            title: "编辑场景失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    },
    editGrouping(data, index) {
      console.log("编辑分组");
      this.ifEditGroupingtitle = `menuTitleInput${index}`;
      this.$nextTick(function () {
        this.$refs[`menuTitleInput${index}`][0].focus();
      });
    },
    // 项目概况小图标事件 修改title
    editGroupingtitle(data) {
      this.$NProgress.set(0.8).inc(0.2);
      this.ifEditGroupingtitle = null;
      console.log(data);
      editBimPlanGrouping({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        pId: data.pId,
        id: data.id,
        planId: this.$route.params.scenarioGroupId,
        name: data.name,
      })
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.getSchemeTree();
            this.$notify({
              title: "编辑分组成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.$NProgress.done(true);
          } else {
            this.$notify({
              title: "编辑分组失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "编辑分组失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    },
    // 项目概况小图标事件 删除分组
    deleteGrouping(item, index) {
      this.$NProgress.set(0.8).inc(0.2);
      console.log("删除分组", this.grouping, item.id);
      deleteBimPlanGrouping({
        id: item.id,
      })
        .then((res) => {
          this.getSchemeTree();
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.$notify({
              title: "删除分组成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.$NProgress.done(true);
          } else {
            this.$notify({
              title: "删除分组失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "删除分组失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    },

    // 项目概况 复制
    copyGrouping(item, index) {
      this.$NProgress.set(0.8).inc(0.2);
      console.log("复制分组", this.grouping, item.id);
      copyBimPlanGrouping({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        id: item.id,
      })
        .then((res) => {
          this.getSchemeTree();
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.$notify({
              title: "复制分组成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.$NProgress.done(true);
          } else {
            this.$notify({
              title: "复制分组失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "复制分组失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    },
    // 过滤场景图层树方法
    filterSceneResource(value, data) {
      if (this.screeningSceneResouece && data.ifResources) {
        if (!value) return true;
        return data.title.indexOf(value) !== -1;
      }
      if (!this.screeningSceneResouece) {
        if (!value) return true;
        return data.title.indexOf(value) !== -1;
      }
    },
    // 筛选
    screeningShow(value) {
      this.screeningSceneResouece = !this.screeningSceneResouece;
      if (this.screeningSceneResouece) {
        this.$refs.scenerResource.$refs.modalTree[0].$refs.sceneResourcetree.filter(
          value
        );
        this.modalNode.scenerResourceTree.content.filterButton.icon =
          "las la-filter laFilterBlue";
      } else {
        this.$refs.scenerResource.$refs.modalTree[0].$refs.sceneResourcetree.filter(
          value
        );
        this.modalNode.scenerResourceTree.content.filterButton.icon =
          "las la-filter laFilterGrey";
      }
    },
    // 打开场景图层树
    openSceneTree() {
      this.isSceneTreeShow = !this.isSceneTreeShow;
      if (this.isSceneTreeShow) {
        const params = {
          projectId: window.sessionStorage.getItem("nowProjectId"),
          scenesId: this.selectedScene.id,
        };
        Promise.all([
          getDropDownList(params),
          getKmlDropDownList(params),
          getShpInfoDropDownList(params),
          getBimPlanPaintingDropDownList(params),
          getDropDownTreeList(params),
        ])
          .then((res) => {
            const [response1, response2, response3, response4, response5] = res;
            // 模型
            const data1 = response1.data.data;
            this.resourceOptions.model = data1[0].children.length ? data1 : [];

            // kml
            const data2 = response2.data.data;
            this.resourceOptions.kml = data2[0].children.length ? data2 : [];

            // shp
            const data3 = response3.data.data;
            this.resourceOptions.shp = data3[0].children.length ? data3 : [];

            // plot
            const data4 = response4.data.data;
            this.resourceOptions.plot = data4[0]?.children.length ? data4 : [];

            // pit
            const data5 = response5.data.data;
            this.resourceOptions.pit = data5[0].children.length ? data5 : [];

            //解构赋值
            const { model, kml, shp, plot, pit } = this.resourceOptions;
            const list = [...model, ...kml, ...shp, ...plot, ...pit];

            // 递归
            const result = this.ifResourcesCheck(list);

            // 赋值
            this.modalNode.scenerResourceTree.content.treeDataJson = result;
          })
          .catch((err) => {
            this.$notify({
              title: "获取失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          });
      } else {
        // 取消筛选，恢复icon，清空输入框
        this.screeningSceneResouece = false;
        this.modalNode.scenerResourceTree.content.filterButton.icon =
          "las la-filter laFilterGrey";
        this.$refs.scenerResource.$refs.modalTree[0].clearFilterText();
      }
    },
    // 关闭场景图层树
    closeSceneTree() {
      // 关闭树，取消筛选，恢复icon，清空输入框
      this.isSceneTreeShow = false;
      this.screeningSceneResouece = false;
      this.modalNode.scenerResourceTree.content.filterButton.icon =
        "las la-filter laFilterGrey";
      this.$refs.scenerResource.$refs.modalTree[0].clearFilterText();
    },
    // 新场景图层树递归
    ifResourcesCheck(data) {
      let options = {
        model: [],
        kmlShp: [],
        plot: [],
      };
      this.$GLOBAL.map.getLayers().forEach((item) => {
        if (item.type == "3dtiles") {
          options.model.push(item.options.modelId);
        }
        if (item.type == "kml2json") {
          options.kmlShp.push(item.options.Kmlid);
        }
        if (item.type == "geojson") {
          if (item.options.modelId) options.kmlShp.push(item.options.modelId);
        }
      });
      console.log(this.$GLOBAL.plotItemLayer);
      if (this.$GLOBAL.plotItemLayer) {
        this.$GLOBAL.plotItemLayer.getGraphics().forEach((item) => {
          if (item.id) options.plot.push(item.id);
        });
      }
      if (data && data.length > 0) {
        data.forEach((item) => {
          // KML SHP
          if (item.kmlInfo || item.shpInfo) {
            const kmlShpValue = options.kmlShp.find((etem) => etem === item.id);
            if (kmlShpValue) {
              item.ifResources = true;
            } else {
              item.ifResources = false;
            }
          }
          // model
          if (item.bimModel) {
            const bimModelValue = options.model.find(
              (etem) => etem === item.bimModel.embsId
            );
            if (bimModelValue) {
              item.ifResources = true;
            } else {
              item.ifResources = false;
            }
          }
          // plot
          if (item.bimPlanPainting) {
            const plotValue = options.plot.find(
              (etem) =>
                JSON.parse(item.bimPlanPainting.graphic) &&
                etem == JSON.parse(item.bimPlanPainting.graphic).id
            );
            if (plotValue) {
              item.ifResources = true;
            } else {
              item.ifResources = false;
            }
          }
          // 递归
          if (item.children?.length) {
            this.ifResourcesCheck(item.children);
          }
        });
      }
      return data;
    },
    // 项目概况 添加分组
    addGrouping(data) {
      this.$NProgress.set(0.8).inc(0.2);
      addBimPlanGrouping({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        pId: 0,
        planId: this.$route.params.scenarioGroupId || 0,
        name: "新分组标题",
      })
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.getSchemeTree();
            this.$notify({
              title: "添加分组成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.$NProgress.done(true);
          } else {
            this.$notify({
              title: "添加分组失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "添加分组失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    },
    // 点击某一个项目概况 场景
    thumbnailClick: _.debounce(function (item, sceneActive, parent) {
      if (this.itemTreeData.isShow) this.itemTreeData.isShow = false;
      if (parent && this.filterProgramText != "") {
        this.screenActiveNames = `${parent.weight - 1}-${item.sort - 1}`;
      } else {
        this.screenActiveNames = null;
      }
      this.$NProgress.done(true);
      this.$parent.$parent.open_box = "";
      this.closeSceneTree();
      this.getScenarioInformation(item);
      // 此处加了一个施工模拟请求
      detailBimConstructSimGrouping({
        sceneId: item.id,
      }).then((res) => {
        let { code, data } = res.data;
        data.forEach((item) => {
          item.children.forEach((e, index) => {
            e.name = `${item.name}-时间区域${index + 1}`;
          });
        });
        mapWorkAnimation.getAnimation(data);
      });
      getBimPlanScenesMethodList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        scenesId: item.id,
      })
        .then((res) => {
          let { data, code } = res.data;
          if (code == 200 || code == 204) {
            if (!window.screenplay) {
              window.screenplay = new Screenplay(
                data.methodList,
                this.complexMovements
              );
            } else {
              screenplay.getScreenplay(data.methodList);
              // screenplay.addKeydown();
            }
            if (sceneActive) {
              this.sceneActive = sceneActive;
            }

            if (screenplayData && screenplayData[item.id] != undefined) {
              item.screenplay = JSON.parse(
                JSON.stringify(screenplayData[item.id])
              );
            } else {
              item.screenplay = [];
            }

            console.log(this.sceneId, item);
            // if (this.sceneId != data.id) {

            this.showMapSwiper(false);
            // 取消延迟动画
            if (screenplay.timer) clearTimeout(screenplay.timer);

            item.screenplay = data.methodList;

            /******
              2023.7.4 - 来源于重复点击场景,标绘不能编辑bug
              张: 
                此处存疑 按逻辑是不需要调用次步骤
           
            // 传递数据过去，告知当前渲染标绘数据
            // plotOperation.receivePlotTreeData({
            //   children: data.paintingData,
            //   parentId: item.id,
            // });

             *******/
            modelCut.getCutList(data.modeSlicedData);
            console.log("treeDataJson1", data.paintingData);
            // 调用子组件方法删除图层
            try {
              this.$refs.poltItemRef.createPlotItemLayer();
            } catch (error) {
              console.log(error);
            }
            this.pause();
            this.modalNodeEdit.viewpointTourEdit.show = false;
            this.selectedScene = item;
            console.log(Object.keys(this.modalIf));
            Object.keys(this.modalIf).forEach((item) => {
              if (item == "part") {
                this.modalIf[item] = true;
              } else {
                this.modalIf[item] = false;
              }
            });
            this.sceneId = item.id;
            this.scenePid = item.pId;

            try {
              screenplayFn.splitScreen.init();
            } catch (error) {
              console.log(error);
            }
            this.$refs.poltItemRef.getData(item.id).then((data) => {
              // console.log("treeDataJson4", item);
              this.handleNodeClick(item);
            });

            // 展示图片
            // if (data.imgList) {
            //   this.imgList = data.imgList;

            //   this.showimg = true;
            // } else {
            //   this.imgList = [];
            //   this.showimg = false;
            // }
            this.ifScreenplay = false;
          } else {
            this.$notify({
              title: "获取操作失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "获取操作失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    }, 500),

    menuOperate(e, list, htmlText) {
      const type = e.currentTarget.dataset.type;
      list.forEach((item) => {
        item.src = item.id;
        item.text = item.remarks;
      });
      if (type == "image") {
        this.imgList = list;
        this.articleString = htmlText;
        this.showimg = true;
      }
      if (type == "play") {
        this.videoList = list;
        this.showVideo = true;
      }
    },
    // 添加场景之后再给其添加一些标绘数据 (假数据)

    // 添加场景
    addScenes(data) {
      console.log("添加场景", data);
      addBimPlanScenes({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        pId: data.id,
        planId: this.$route.params.scenarioGroupId || 0,
        name: "新场景标题",
        type: "theEssential",
        url: "",
        content: "",
        ontentTime: 0,
        isAreaShow: false,
        areaLocation: "l-t",
      })
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.getSchemeTree();
            this.$notify({
              title: "添加场景成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.modalIf.sceneInformation = false;
            this.$NProgress.done(true);
          } else {
            this.$notify({
              title: "添加场景失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "添加场景失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    },
    leftChildrenHandleCommand(command) {
      let { index, item, type } = command;
      switch (type) {
        case "rename":
          this.sceneRename(item, index);
          break;
        case "edit":
          this.editScenes(item, index);
          break;
        case "copy":
          getBimPlanAllGrouping({
            projectId: sessionStorage.getItem("nowProjectId"),
          }).then((res) => {
            this.isReplicatedDirectory = false;
            this.replicatedDirectoryProps = {
              type: "scene",
              groupingItem: res.data.data,
              currentKey: item.pId,
              currentSceneId: item.id,
            };
            this.$nextTick(() => {
              this.isReplicatedDirectory = true;
            });
          });
          // if (this.grouping && this.grouping.length > 1) {
          //   this.isReplicatedDirectory = false;
          //   this.replicatedDirectoryProps = {
          //     type: "scene",
          //     groupingItem: this.grouping,
          //     currentKey: item.pId,
          //     currentSceneId: item.id,
          //   };
          //   this.$nextTick(() => {
          //     this.isReplicatedDirectory = true;
          //   });
          // } else {
          //   this.copyOperation(item, index);
          // }
          break;
        case "delete":
          this.$confirm("确认删除？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.deleteScenes(item, index);
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消",
              });
            });

          break;
        case "subscenes":
          this.addSubscenes();
          break;
      }
    },
    changeInfoRefreshPlotTree() {
      this.$refs.poltItemRef.getData();
    },
    // 从标绘树编辑标绘
    handlePlotEdit(data, node) {
      this.$GLOBAL.plotItemLayer.stopEditing();
      plotOperation.operationPlotData(true, data.id);
      // 传给组件
      this.currentPlotPidNode = data.bimPlanPainting.pId
        ? data.bimPlanPainting.pId
        : data.parentId;
      this.$refs.plotItemImg.resourcesHttp(
        data.bimPlanPainting.dataType,
        data.bimPlanPainting.pId ? data.bimPlanPainting.pId : data.parentId
      );
      const oldGraphic = this.$GLOBAL.plotItemLayer.getGraphicById(
        JSON.parse(data.bimPlanPainting.graphic).id
      );
      // 有旧数据并且存在图层中
      if (oldGraphic) {
        oldGraphic.startEditing();
        const model = plotOperation.manageFields(data);
        // 打开编辑属性框
        this.isPlotItemShow = true;
        this.$nextTick(() => {
          // 显示对应的属性编辑，传递form数据
          this.$refs.plotItemImg.initFormData(
            data.bimPlanPainting.customType,
            JSON.parse(data.bimPlanPainting.graphic).id
          );
          this.$refs.plotItemImg.initItemsArr(data.bimPlanPainting.customType);
          this.$refs.plotItemImg.editMergeForm(
            model,
            data.bimPlanPainting.dataType,
            data.bimPlanPainting.pId,
            -425
          );
        });
      } else {
        // 没有旧数据去查
        const graphic = plotOperation.flyToPlot(data.id, "edit");
        if (graphic) {
          // 开启编辑（支持拖动）
          graphic.drawGraphic.startEditing();
          // 打开编辑属性框
          this.isPlotItemShow = true;
          // 显示对应的属性编辑，传递form数据
          this.$refs.plotItemImg.initFormData(
            graphic.current.bimPlanPainting.customType,
            graphic.current.uid
          );
          this.$refs.plotItemImg.initItemsArr(data.bimPlanPainting.customType);
          const data = plotOperation.manageFields(graphic.current);
          this.$refs.plotItemImg.editMergeForm(
            data,
            data.bimPlanPainting.dataType,
            data.bimPlanPainting.pId,
            -425
          );
        }
      }
    },
    // 编辑场景
    editScenes(data, index) {
      this.modalIf.part = false;
      this.modalNodeScenes.sceneInformationTree.loading = true;
      this.modalNodeScenes.sceneInformationTree.height = `${
        document.querySelector("#mars3d-container").offsetHeight - 30
      }px`;

      let item = JSON.parse(JSON.stringify(data.scenesData[index]));

      this.submitPartData.alt = item.alt;
      this.submitPartData.heading = item.heading;
      this.submitPartData.lat = item.lat;
      this.submitPartData.lng = item.lng;
      this.submitPartData.pitch = item.pitch;
      this.submitPartData.duration = item.duration;
      this.submitPartData.stop = item.stop;
      this.getScenarioInformation(item);
      this.sceneId = item.id;
      this.scenePid = item.pId;
      this.$parent.$parent.open_box = "";
      // 获取编辑场景的下拉数据源
      getDropDownGroupingList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        planId: this.$route.params.scenarioGroupId || 0,
      })
        .then((res) => {
          let { data, code } = res.data;
          if (code == 200 || code == 204) {
            this.modalNodeScenes.sceneInformationTree.content.formData.pId.options =
              data;
          }
          // this.modalNodeScenes.sceneInformationTree.loading = false;
        })
        .catch((error) => {
          // this.modalNodeScenes.sceneInformationTree.loading = false;
          console.log("获取失败", error);
        });
      Object.keys(this.modalIf).forEach((item) => {
        this.modalIf[item] = false;
      });
      this.modalIf.sceneInformation = true;
      this.$nextTick((res) => {
        this.modalIf.part = true;
      });
    },
    // 删除场景
    deleteScenes(data, index) {
      deleteBimPlanScenes({
        id: data.scenesData[index].id,
      })
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.getSchemeTree();
            this.$notify({
              title: "删除场景成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.$NProgress.done(true);
          } else {
            this.$notify({
              title: "删除场景失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "删除场景失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    },
    // 点击场景树
    nodeClick(data) {
      if (data.type == "model") {
        let layer = this.$GLOBAL.map.getLayerById(data.uid);
        layer.flyTo({
          duration: 3,
        });
      } else if (data.type == "img") {
        this.showimg = true;
      }
    },
    // 关闭场景信息
    sceneInformationClose() {
      this.modalIf.sceneInformation = false;
      this.modalIf.part = false;
    },
    // 开启资源树
    scenerResourceShow(id) {
      if (id) this.getScenesTreeNodeList(id);
    },
    // 关闭场景树
    scenerResourceClose() {},

    // 暂停漫游
    pause() {
      this.$GLOBAL.map.cancelFlight();
      this.playState = null;
      screenplayFn.rotatePoint.init();
      screenplayFn.rotatePoint.fly("stop", "");
    },
    // 漫游事件
    play(item, index) {
      this.playState = index;
      this.modalNodeEdit.viewpointTourEdit.show = false;
      Object.keys(this.modalIf).forEach((item) => {
        this.modalIf[item] = false;
      });
      this.sceneKey = -1;
      let path = [];
      this.selectedPlan = item;
      pointLayer && pointLayer.destroy();
      textLayer && textLayer.destroy();
      pointLayer = null;
      textLayer = null;
      item.scenesData.forEach((z, index) => {
        if (z.coordinate) {
          z.coordinate.index = index;
          path.push(z.coordinate);
        }
        if (z.children)
          z.children.forEach((i) => {
            if (i.coordinate) {
              path.push(i.coordinate);
            }
          });
      });
      this.routeData = path;
      this.routeData.forEach((g) => {
        g.onEnd = this.sceneOperation;
      });
      this.$GLOBAL.map.setCameraViewList(this.routeData, {
        complete: () => {
          console.log("漫游完成");
          pointLayer && pointLayer.destroy();
          textLayer && textLayer.destroy();
          pointLayer = null;
          textLayer = null;
        },
      });
    },
    sceneOperation() {
      this.sceneKey += 1;
      // this.selectedPlan.scenesData[this.routeData[this.sceneKey].index];
      let itemScenesData =
        this.selectedPlan.scenesData[this.routeData[this.sceneKey].index];
      if (itemScenesData) {
        pointLayer && pointLayer.destroy();
        textLayer && textLayer.destroy();
        pointLayer = null;
        textLayer = null;
        this.submitPartData.content = itemScenesData.content;
        this.submitPartData.title = itemScenesData.title;
        console.log(itemScenesData.content);
        this.modalIf.part = true;

        let _this = this,
          timeoutID = null;
        timeoutID = setTimeout(() => {
          _this.deleteChildmodal("part");
        }, 2000);

        Object.keys(itemScenesData.vectorData).forEach((key) => {
          // console.log("showimg", itemScenesData);
          if (key == "arrPointText") {
            const arrPoint = itemScenesData.vectorData[key].point;
            console.log(arrPoint);
            pointLayer = this.createArrPoint(arrPoint); // 添加点
            textLayer = this.createArrText(
              arrPoint,
              itemScenesData.vectorData[key].text
            ); // 添加注记
          }
        });
      }
    },

    //  ************************************************左侧菜单 END************************************************

    //  ************************************************ 场景信息 ************************************************
    // 点击某一个场景 给对应场景传递一个确认提交事件
    onPartSubmit() {
      let { id, title, content } = this.submitPartData;
      console.log("onPartSubmit", this.submitPartData);
      // 暗挖段

      try {
        this.grouping.forEach((item) => {
          if (item.scenesData.find((f) => f.id == id))
            throw item.scenesData.find((f) => f.id == id);
        });
      } catch (e) {
        console.log(e, this.submitPartData);
        let {
          title,
          id,
          isAreaShow,
          content,
          url,
          areaLocation,
          // 视角
          alt,
          heading,
          lat,
          lng,
          pitch,
          duration,
          pId,
          stop,
          width,
          height,
        } = this.submitPartData;
        editBimPlanScenes({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          id,
          pid: pId,
          name: title,
          type: "theEssential",
          url,
          content,
          ontentTime: 0,
          isAreaShow,
          areaLocation,
          alt,
          heading,
          lat,
          lng,
          pitch,
          duration,
          stop,
          width,
          height,
        })
          .then((res) => {
            let { code } = res.data;
            if (code == 200 || code == 204) {
              this.getSchemeTree();
              this.$notify({
                title: "修改场景成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              this.$NProgress.done(true);
              this.stretchModal();
              this.sceneInformationClose();
              try {
                screenplayFn.splitScreen.init();
                screenplay.initial("notAutomatically");
              } catch (error) {
                console.log(error);
              }
              // screenplay.initial();

              this.sceneActive = "";
              // this.sceneId = 0
            } else {
              this.$notify({
                title: "修改场景失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          })
          .catch((error) => {
            console.log(error);
            this.$notify({
              title: "修改场景失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          });
      }
    },
    // 保存视角之后的截图事件
    mapImg() {
      let { id } = this.submitPartData;
      this.$GLOBAL.map.expImage({
        download: false,
        width: 200,
        callback: (image) => {
          this.grouping.forEach((item) => {
            if (item.scenesData.find((f) => f.id == id)) {
              item.scenesData.find((f) => f.id == id).url = image;
              let { alt, heading, lat, lng, pitch } =
                this.$GLOBAL.map.getCameraView();
              console.log(alt, heading, lat, lng, pitch, item);
              this.submitPartData.alt = alt;
              this.submitPartData.heading = heading;
              this.submitPartData.lat = lat;
              this.submitPartData.lng = lng;
              this.submitPartData.pitch = pitch;
              this.$notify({
                title: "成功截取视角，请保存",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
            }
          });
        },
      });
    },
    // 给场景测绘树添加数据
    addSceneResources(key, data) {
      let arr = [];
      this.selectedScene.treeDataJson.forEach((item) => {
        // 判断项应为获取的变量
        if (item.key == key) {
          data.forEach((i) => {
            const text = i.style.label.mapText;
            arr.push({
              uid: i.id,
              id: i.id,
              text: text,
              type: key,
            });
          });
          item.children = arr;
        }
      });
    },
    // 给场景资源树删除数据
    deleteSceneResources(key, uid) {
      this.selectedScene.treeDataJson.some((item) => {
        if (item.key == key) {
          let index;
          item.children.find((i, k) => {
            console.log(i.uid);
            if (i.uid == uid) {
              index = k;
            }
            return i.uid == uid;
          });
          item.children.splice(index, 1);
          return true;
        }
      });
    },

    // 过渡视点
    // 切换
    toggleTransition(item) {
      item.showTransition = !item.showTransition;
    },
    transitionViewpointClose() {
      this.submitViewpointData = {
        id: "",
        url: null,
        text: "",
        alt: 0,
        heading: 0,
        lat: 0,
        lng: 0,
        pitch: 0,
        duration: 0,
        stop: 0,
      };
      this.modalNodeEdit.viewpointTourEdit.show = false;
    },
    onSubmitViewpointt() {
      let { alt, heading, lat, lng, pitch, text, duration, stop } =
        this.submitViewpointData;
      this.modalNodeEditItem.title = text;
      this.modalNodeEditItem.alt = alt;
      this.modalNodeEditItem.heading = heading;
      this.modalNodeEditItem.lat = lat;
      this.modalNodeEditItem.lng = lng;
      this.modalNodeEditItem.pitch = pitch;
      this.modalNodeEditItem.duration = duration;
      this.modalNodeEditItem.stop = stop;
      this.$notify({
        title: "保存成功",
        message: "",
        type: "success",
        duration: 960,
        offset: 320,
      });
    },
    // 不是关键镜头的树 点击事件
    handleNodeClick(data) {
      console.log("handleNodeClick", data);
      let { alt, duration, heading, lat, lng, pitch, stop } = data;
      if (lng && lat && alt && heading && pitch) {
        // 暂停漫游
        this.pause();
        // 暂停绕点飞行

        // 视角飞行
        this.$GLOBAL.map.centerAt(
          {
            y: lat,
            x: lng,
            alt: alt,
            heading: heading,
            pitch: pitch,
          },
          {
            complete: () => {
              // 初始化
              screenplay.initial();
              this.lock = true;
            },
          }
        );
        if (data.type == undefined) {
          Object.keys(this.modalIf).forEach((item) => {
            this.modalIf[item] = false;
          });
          this.modalNodeEdit.viewpointTourEdit.show = true;
          this.modalNodeEditItem = data;
          this.submitViewpointData.text = data.title;
          this.submitViewpointData.duration = duration;
          this.submitViewpointData.alt = alt;
          this.submitViewpointData.heading = heading;
          this.submitViewpointData.lat = lat;
          this.submitViewpointData.lng = lng;
          this.submitViewpointData.pitch = pitch;
          this.submitViewpointData.stop = stop;
        }
      } else {
        screenplay.initial();
      }
    },
    screenshot() {
      let { alt, heading, lat, lng, pitch } = this.$GLOBAL.map.getCameraView();
      // console.log(alt, heading, lat, lng, pitch);
      this.$GLOBAL.map.expImage({
        download: false,
        width: 200,
        callback: (image) => {
          this.submitViewpointData.alt = alt;
          this.submitViewpointData.heading = heading;
          this.submitViewpointData.lat = lat;
          this.submitViewpointData.lng = lng;
          this.submitViewpointData.pitch = pitch;
        },
      });
    },
    //  ************************************************ 场景信息 END************************************************

    //  ************************************************ 顶部 ************************************************
    //设置
    platformSetting() {
      this.basicSettingsShow = !this.basicSettingsShow;
      Object.keys(this.$refs.toolLibrary.model).forEach((e) => {
        this.$refs.toolLibrary.model[e] = false;
      });
    },
    // deleteModelSet() {},
    transparentInit() {
      if (mapWork.underground) {
        this.transparentValue = mapWork.underground.alpha
          ? mapWork.underground.alpha
          : 1;
      }
    },
    ifTransparent(e) {
      if (!e) {
        this.transparentValue = 0;
      } else {
        this.transparentValue = 1;
      }
    },
    transparent: _.debounce(function (data) {
      let map = this.$GLOBAL.map;
      mapWork.setUnderground(this.transparentValue);
      if (this.$GLOBAL.map) {
        this.$GLOBAL.map.getLayers().forEach((item) => {
          if (item.options.modelType == 0) {
            item.opacity = this.transparentValue;
            // let color = `rgba(255,255,255,${this.transparentValue})`;
            // item.style = {
            //   color: {
            //     conditions: [["true", color]],
            //   },
            // };
          }
        });
      } else {
        this.transparentValue = 1;
      }

      this.lock = false;
    }, 1000),

    // 顶部菜单 click事件
    childmodal(data) {
      console.log(data.remark);
      if (data.remark == "unity") {
        window.open("ChuanCha://");
        return false;
      }

      try {
        // screenplay.removeKeydown();
      } catch (e) {
        console.log("screenplay没有定义"); //sojson is undefined
      }
      let modalBoxStatus = () => {
        this.modalNodeEdit.viewpointTourEdit.show = false;
        if (data.remark != "elevationImage") {
          this.$parent.$parent.model.elevationImage = false;
          this.modalIf.elevationImage = false;
        }
        if (
          this.selectedScene != null ||
          data.remark == "pointView" ||
          data.remark == "model" ||
          data.remark == "shp" ||
          data.remark == "terrain" ||
          data.remark == "elevationImage" ||
          data.remark == "trafficSimulation" ||
          data.remark == "viewpoint" ||
          data.remark == "modelSet" ||
          data.remark == "trafficSimulation_PTV" ||
          data.remark == "constructionSimulation" ||
          data.remark == "newModelCut" ||
          data.remark == "plotItem"
        ) {
          Object.keys(this.modalIf).forEach((item) => {
            if (data.remark != "elevationImage") {
              if (item == data.remark && !this.modalIf[item]) {
                this.modalIf[item] = true;
                if (this.selectedScene)
                  this.getScenesTreeNodeList(this.selectedScene.id);
              } else {
                this.modalIf[item] = false;
              }
            } else if (item == "elevationImage") {
              console.log(item, this.modalIf.elevationImage);
              if (this.$parent.$parent.model.elevationImage) {
                this.$parent.$parent.model.elevationImage = false;
                this.modalIf.elevationImage = false;
              } else {
                this.$parent.$parent.model.elevationImage = true;
                this.modalIf.elevationImage = true;
              }
            } else {
              this.modalIf[item] = false;
            }
          });
          this.showimg = false;
          this.sceneInformationClose();
        } else if (data.remark == "imageResources") {
          // console.log(data.remark);
          $(".left-side-bar").addClass("hide");
          // this.$alert("请选择一个场景！！", "提示", {
          //   confirmButtonText: "确定",
          //   type: "error",
          //   callback: (action) => {
          //     this.$refs.elMenu.activeIndex = null;
          //   },
          // });
          this.$message({
            message: "请先选择一个场景",
            type: "warning",
            duration: 2000,
          });
          this.$refs.elMenu.activeIndex = null;
        } else {
          $(".left-side-bar").addClass("hide");
        }
      };
      modalBoxStatus();

      console.log(this.modalIf);
    },
    // 顶部右侧菜单 click事件
    childRmodal(data) {
      console.log(data.remark);
      if (data.remark == "modelSet") {
        console.log("模型库");
        this.childmodal({
          remark: "modelSet",
        });
      }
      if (data.remark == "database") {
        const url = this.$router.resolve({
          name: "BimDatabank",
        });
        window.open(url.href, "_blank");
      }

      // console.log(data);
    },

    // 关闭操作的的模态框
    deleteChildmodal(key) {
      console.log(key);
      this.modalIf[key] = false;
      // this.$refs.elMenu.activeIndex = null;
      this.ifScreenplay = false;
      this.isPlotItemShow = false;
      // screenplay.initial("notAutomatically");
    },
    showChildmodal(key) {
      this.modalIf[key] = true;
      Object.keys(this.modalIf).forEach((item) => {
        if (item == key) {
          this.modalIf[item] = true;
        } else {
          this.modalIf[item] = false;
        }
      });
    },
    //处理菜单配置项
    handlingMenu(fn) {
      if (this.$route.params.stype.indexOf("program") > -1) {
        menuChange({
          application: this.$route.params.stype,
          projectId: window.sessionStorage.getItem("nowProjectId"),
        })
          .then((resL) => {
            if (resL.data.success && resL.data.data) {
              // console.log("顶部菜单", resL.data.data);
              let menuData = [],
                rMenuData = [];
              this.processMenu(resL.data.data, 0).forEach((item) => {
                if (item.meta.position == 0) {
                  menuData.push(item);
                } else if (item.meta.position == 1) {
                  if (item.remark == "toolLibrary") {
                    this.toolLibraryData = item;
                  } else {
                    rMenuData.push(item);
                  }
                }
              });
              console.log("顶部菜单", rMenuData);
              this.elMenuData = JSON.parse(JSON.stringify(menuData));
              this.rElMenuData = JSON.parse(JSON.stringify(rMenuData));
              if (fn) fn();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    processMenu(data, root, idTxt, pidTxt, pushTxt) {
      var idTxt = idTxt || "id";
      var pidTxt = pidTxt || "pid";
      var pushTxt = pushTxt || "children"; // 递归方法
      function getNode(id) {
        var node = [];
        for (var i = 0; i < data.length; i++) {
          if (data[i][pidTxt] == id) {
            let tdata = getNode(data[i][idTxt]);
            if (!tdata) {
              tdata = [];
            }
            data[i][pushTxt] = tdata;

            node.push(data[i]);
          }
        }
        if (node.length == 0) {
          return;
        } else {
          return node;
        }
      } // 使用根节点
      return getNode(root);
    },
    // 右上角 退出按钮
    backtrack(type) {
      // 如果当前是演示模式
      if (this.$store.state.isPresentationMode && type != "return") {
        this.$notify({
          title: "提示",
          message: "已退出演示模式",
          type: "warning",
          duration: 960,
          offset: 320,
        });
        // 刷新顶部菜单
        this.handlingMenu();
        // 关闭演示模式
        this.$store.commit("changePresentationModeState", false);
      } else {
        if (sessionStorage.getItem("IsNew") == "new") {
          window.location.href = process.env.VUE_APP_NEW_URL + "/projects/list";
        } else {
          if (sessionStorage.getItem("appScenarios") != "program") {
            document.body.removeAttribute("class", "program-status");
            this.modalNodeEdit.viewpointTourEdit.show = false;
            Object.keys(this.modalIf).forEach((item) => {
              this.modalIf[item] = false;
            });
            this.$emit("update:programToggle", false);
            console.log("退出程序");
          } else {
            // 卸载挖洞工具
            if (this.$GLOBAL.terrainClipGraphic) {
              this.$GLOBAL.map.removeLayer(this.$GLOBAL.terrainClipGraphic);
              this.$GLOBAL.terrainClipGraphic = null;
            }
            // 卸载挖洞工具
            if (this.$GLOBAL.terrainClip) {
              this.$GLOBAL.map.removeThing(this.$GLOBAL.terrainClip);
              this.$GLOBAL.terrainClip = null;
            }
            // 卸载标绘图层
            this.$GLOBAL.map.removeLayer(this.$GLOBAL.plotItemLayer);
            this.$GLOBAL.plotItemLayer = null;
            // 释放打开图片弹窗方法
            window.menuOperate = null;
            // 去项目列表
            this.$router.push("/projectsList");
            this.$router.go(0);
          }
        }
      }
    },

    //  ************************************************ 顶部END ************************************************
    // 方案树筛选清空
    clearProgram() {
      this.getSchemeTree();
      if (this.screenActiveNames) {
        let programActiveNames = this.screenActiveNames.split("-")[0];
        this.programActiveNames = [parseInt(programActiveNames)];
        this.sceneActive = JSON.parse(JSON.stringify(this.screenActiveNames));
      } else {
        this.programActiveNames = null;
      }
    },
    filterProgram() {
      this.getSchemeTree(this.filterProgramText);
      this.programActiveNames = [0];
      if (window.screenplay) {
        screenplay.initial("notAutomatically");
      }

      this.sceneActive = "";
      this.modalIf.part = false;
    },

    // 读取方案树数据
    getSchemeTree(searchValue = "") {
      if (
        document.querySelector(
          ".program-change-information-left-menu .el-scrollbar .el-scrollbar__wrap"
        )
      )
        window.scenesTreeNodeListScrollTop = document.querySelector(
          ".program-change-information-left-menu .el-scrollbar .el-scrollbar__wrap"
        ).scrollTop;
      this.$NProgress.set(0.8).inc(0.2);
      this.grouping = [];
      const loading = this.$loading({
        lock: true,
        text: "数据加载中",
        spinner: "el-icon-loading",
        background: "rgba(12, 18, 30, 0.2)",
      });
      if (searchValue == "") {
        this.filterProgramText = "";
      }
      treeNodeList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        pId: 0,
        planId: this.$route.params.scenarioGroupId || 0, // 方案id
        searchValue: searchValue,
      })
        .then((res) => {
          this.grouping = res.data.data;

          if (this.selectedScene && this.sceneActive) {
            this.selectedScene =
              this.grouping[this.sceneActive.split("-")[0]].scenesData[
                this.sceneActive.split("-")[1]
              ];
          }

          // this.$nextTick(() => {

          // });
          setTimeout(() => {
            this?.rowDrop();
            document
              .querySelector(
                ".program-change-information-left-menu .el-scrollbar .el-scrollbar__wrap"
              )
              .scrollTo({
                top: window.scenesTreeNodeListScrollTop,
                behavior: "smooth",
              });

            window.scenesTreeNodeListScrollTop = 0;
          }, 500);
          this.updateScenesTreeNodeList();
          this.$NProgress.done(true);
          loading.close();
          // console.log(
          //   "scenesTreeNodeListScrollTop",
          //   window.scenesTreeNodeListScrollTop,
          //   document.querySelector(
          //     ".program-change-information-left-menu .el-scrollbar .el-scrollbar__wrap"
          //   ).scrollTop
          // );
        })
        .catch((res) => {
          loading.close();
          console.log(res);
          this.$notify({
            title: "加载失败，请重试！",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
    updateScenesTreeNodeList() {
      if (this.sceneId != 0 && this.scenePid != 0) {
        this.grouping.find((item) => {
          if (item.id == this.scenePid) {
            item.scenesData.find((i) => {
              if (i.id == this.sceneId) {
                this.getScenesTreeNodeList(i.id);
              }
            });
          }
        });
      }
    },
    // 获取资源树数据
    getScenesTreeNodeList(id, fn) {
      this.modalNode2.scenerResourceTree.loading = true;
      this.modalNode2.scenerResourceTree.content.treeDataJson = [];
      getScenesTreeNodeList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        id: id,
      })
        .then((res) => {
          let { data } = res.data;

          data.treeDataJson.forEach((i) => {
            i.children.forEach((item) => {
              item.ifResources = false;
            });
          });
          this.modalNodeData = data.treeDataJson;

          this.resourceTreeCheck();
          this.modalNode2.scenerResourceTree.content.treeDataJson =
            this.modalNodeData;
          if (fn) fn();
          this.modalNode2.scenerResourceTree.loading = false;
        })
        .catch((res) => {
          console.log(res);
          // loading.close();
          this.$notify({
            title: "加载失败，请重试！",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
    resourceTreeCheck(type, data = this.modalNodeData) {
      if (type == "init") {
        this.modalNode2.scenerResourceTree.content.treeDataJson.forEach((i) => {
          i.children.forEach((item) => {
            item.ifResources = false;
          });
        });

        this.modalNode2.scenerResourceTree.content.treeDataJson =
          this.modalNodeData;
        this.$forceUpdate();
      } else {
        let options = {
          model: [],
          kmlShp: [],
          plot: [],
        };
        // console.log("标绘", this.$GLOBAL.plotItemLayer.getGraphics());
        this.$GLOBAL.map.getLayers().forEach((item) => {
          if (item.type == "3dtiles") {
            options.model.push(item.options.modelId);
          }
          if (item.type == "kml2json") {
            options.kmlShp.push(item.options.Kmlid);
          }
          if (item.type == "geojson") {
            if (item.options.modelId) options.kmlShp.push(item.options.modelId);
          }
        });
        if (
          this.$GLOBAL.plotItemLayer._state != "destroy" &&
          this.$GLOBAL.plotItemLayer
        ) {
          this.$GLOBAL.plotItemLayer.getGraphics()?.forEach((item) => {
            if (item.id) options.plot.push(item.id);
          });
        }

        // 处理资源树模型
        if (data[0].children.length > 0) {
          options.model.forEach((item) => {
            data[0].children.find((i) => {
              if (item == i.bimModel.embsId) {
                i.ifResources = true;
              }
            });
          });
        }

        // 处理资源树kml
        if (data[3].children.length > 0) {
          options.kmlShp.forEach((item) => {
            data[3].children.find((i) => {
              console.log(item == i.id);
              if (item == i.id) {
                i.ifResources = true;
              }
            });
          });
        }

        // 标绘
        if (data[2].children.length > 0) {
          options.plot.forEach((item) => {
            data[2].children.find((i) => {
              if (item == JSON.parse(i.bimPlanPainting.graphic).id) {
                i.ifResources = true;
              }
            });
          });
        }
      }
    },

    // 拖动
    rowDrop() {
      // 要侦听拖拽响应的DOM对
      console.log("要侦听拖拽响应的DOM对", this.sortableUl, this.sortableLi);
      const ul = document.querySelector(".el-collapse");
      const li = $(".program-thumbnail");
      const _this = this;
      this.sortableUl = Sortable.create(ul, {
        draggable: ".isCollapseDrop",
        // 结束拖拽后的回调函数
        animation: 300,
        dataIdAttr: "data-mode-ui-id",
        filter: ".filter",
        onEnd(e) {
          // console.log(sortableUl.toArray());
          _this.postBimPlanGroupingEditSort(
            _this.sortableUl.toArray().map(Number)
          );
        },
      });
      this.sortableLi = {};
      li.each((index, item) => {
        this.sortableLi[`sortableLi${index}`] = Sortable.create(item, {
          draggable: ".isChildrenDrop",
          // 结束拖拽后的回调函数
          animation: 300,
          dataIdAttr: "data-mode-li-id",
          filter: ".filter",
          onUpdate: (event) => {
            this.ifSwitchScenes = false;
            console.log(event);
            var newIndex = event.newIndex,
              oldIndex = event.oldIndex,
              $li = event.from.children[newIndex],
              $oldLi = event.from.children[oldIndex];
            // 先删除移动的节点
            event.from.removeChild($li);
            // 再插入移动的节点到原有节点，还原了移动的操作
            if (newIndex > oldIndex) {
              event.from.insertBefore($li, $oldLi);
            } else {
              event.from.insertBefore($li, $oldLi.nextSibling);
            }
            // 更新items数组
            var item = _this.grouping[
              $(event.from).parents(".el-collapse-item").index()
            ].scenesData.splice(oldIndex, 1);
            _this.grouping[
              $(event.from).parents(".el-collapse-item").index()
            ].scenesData.splice(newIndex, 0, item[0]);
            // 下一个tick就会走patch更新
            let arr = [];
            _this.grouping[
              $(event.from).parents(".el-collapse-item").index()
            ].scenesData.forEach((item) => {
              // console.log(item);
              arr.push(item.id);
            });

            console.log(arr);
            _this.postBimPlanScenesEditSort(arr);
          },
          // onEnd(e) {
          //   console.log(_this.sortableLi[`sortableLi${index}`]);
          //   _this.postBimPlanScenesEditSort(
          //     _this.sortableLi[`sortableLi${index}`]
          //       .toArray()
          //       .slice(0, -1)
          //       .map(Number)
          //   );
          // },
        });
      });
    },
    postBimPlanScenesEditSort: _.debounce(function (data) {
      let dataList = {
        IdSortList: data,
      };
      postBimPlanScenesEditSort(dataList)
        .then((res) => {
          let { data, code } = res.data;
          if (code == 200 || code == 204) {
            let sonIndex;
            if (this.sceneId != 0 && this.sceneActive != "") {
              console.log(this.grouping, this.sceneActive.split("-")[0]);
              this.grouping[this.sceneActive.split("-")[0]].scenesData.find(
                (item, index) => {
                  if (item.id == this.sceneId) {
                    sonIndex = index;
                  }
                }
              );
              this.sceneActive = `${
                this.sceneActive.split("-")[0]
              }-${sonIndex}`;
            }
            this.ifSwitchScenes = true;
          } else {
            this.$notify({
              title: "排序失败,请刷新页面",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "排序失败,请刷新页面",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    }, 1500),

    postBimPlanGroupingEditSort: _.debounce(function (data) {
      let dataList = {
        IdSortList: data,
      };
      postBimPlanGroupingEditSort(dataList)
        .then((res) => {
          let { data, code } = res.data;
          if (code == 200 || code == 204) {
            console.log(data);
          } else {
            this.$notify({
              title: "排序失败,请刷新页面",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "排序失败,请刷新页面",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    }, 1500),

    keyDownFn(event) {
      if (this.$store.state.isPresentationMode && this.$refs.switchScenes) {
        if (event.keyCode == 40) {
          this.$refs.switchScenes.nextAction();
        }
        if (event.keyCode == 39) {
          this.$refs.switchScenes.nextPage();
        }
        if (event.keyCode == 37) {
          this.$refs.switchScenes.previousPage();
        }
      }
    },
    // 初始化
    init() {
      $(".left-side-bar").addClass("hide");
      if (sessionStorage.getItem("appScenarios") != "program") {
        document.getElementsByTagName("body")[0].className = "program-status";
      }
      this.handlingMenu(this.changePresentationModeStateMethod);
      // this.grouping = grouping;
      this.programActiveIndex = null;
      this.$nextTick(() => {
        console.log(
          "高度修改",
          document.body.clientHeight && document.documentElement.clientHeight
        );
        this.modalNodeScenes.sceneInformationTree.height = `${
          document.querySelector("#mars3d-container").offsetHeight - 30
        }px`;
      });

      this.getSchemeTree();

      window.addEventListener("keydown", this.keyDownFn);

      this.$notify({
        title: "操作提示",
        message: `⭠ / ⭢ 键可切换场景`,
        type: "warning",
        duration: 2000,
        offset: 320,
      });

      //         const toolButton = new mars3d.control.ToolButton({
      //   title: "提示",
      //   icon: `<svg:svg class="cesium-svgPath-svg" width="32" height="32" viewBox="0 0 32 32"><path d="M16,1.466C7.973,1.466,1.466,7.973,1.466,16c0,8.027,6.507,14.534,14.534,14.534c8.027,0,14.534-6.507,14.534-14.534C30.534,7.973,24.027,1.466,16,1.466z M17.328,24.371h-2.707v-2.596h2.707V24.371zM17.328,19.003v0.858h-2.707v-1.057c0-3.19,3.63-3.696,3.63-5.963c0-1.034-0.924-1.826-2.134-1.826c-1.254,0-2.354,0.924-2.354,0.924l-1.541-1.915c0,0,1.519-1.584,4.137-1.584c2.487,0,4.796,1.54,4.796,4.136C21.156,16.208,17.328,16.627,17.328,19.003z"></path></svg:svg>`,
      //   className: ".tool_bookmark_btn",
      //   insertIndex: 0, // 插入的位置顺序, 1是home按钮后面
      //   click: () => {
      //           this.$notify({
      //       title: "操作提示",
      //       message: `⭠ / ⭢ 键可切换场景`,
      //       type: "warning",
      //       duration: 2000,
      //       offset: 320,
      //     });
      //   }
      // })
      // this.$GLOBAL.map.addControl(toolButton);
    },

    // 复杂动作
    complexInit() {
      this.showMapSwiper(false);
    },
    complexMovements(item, state) {
      if (state) {
        switch (item.operate[0].type) {
          case "show-image":
            this.showMapSwiper(true, item.operate[0].list);
            break;
          default:
            break;
        }
      } else {
        this.complexInit();
      }
    },

    // 展示轮播图操作
    showMapSwiper(state, list) {
      if (state) {
        this.imgList = list;
        this.showimg = true;
      } else {
        this.imgList = [];
        this.showimg = false;
      }
    },
    // 复制场景
    copyOperation: _.debounce(function (data, sceneActive) {
      this.$NProgress.configure({
        easing: "ease",
        showSpinner: true,
      });
      this.$NProgress.set(0.8).inc(0.2);
      copyPlanScenes({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        id: data.id,
      })
        .then((res) => {
          let { data, code } = res.data;
          if (code == 200 || code == 204) {
            this.getSchemeTree();
            this.$notify({
              title: "复制成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
          } else {
            this.$notify({
              title: "复制失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
          this.$NProgress.done(true);
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "复制失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    }, 500),

    // 开启操作
    openAction: _.debounce(function (data, sceneActive) {
      this.$parent.$parent.open_box = "";
      if (!window.screenplay) {
        window.screenplay = new Screenplay([], this.complexMovements);
      } else {
        // screenplay.getScreenplay(data);
      }

      if (this.selectedScene?.id != data.id) {
        screenplay.initial("notAutomatically");
      }

      if (sceneActive) {
        this.sceneActive = sceneActive;
      }
      this.selectedScene = data;
      this.sceneId = data.id;
      this.scenePid = data.pId;
      this.getScenesTreeNodeList(data.id);
      Object.keys(this.modalIf).forEach((item) => {
        this.modalIf[item] = false;
      });
      this.ifScreenplay = true;

      // screenplay.initial("notAutomatically");
    }, 200),

    screenplayModelClose() {
      this.ifScreenplay = false;
      // screenplay.initial("notAutomatically");
      // this.sceneActive = "";
      // this.scenerResourceClose();
    },

    // 递归处理树数据
    recursion(data) {
      data.forEach((item) => {
        if (item.children.length > 0) {
          this.recursion(item.children);
        } else {
          if (item.bimModel.isDisplay) {
            // 初始化选中
            // this.initBimModelArr.push(item.id);
            // 初始化添加模型
            // this.addModel(item, "init");
          }

          if (item.bimModel.modelType == 0) {
            this.$GLOBAL.osgbTilesetLayerIds.push(item.id); //记录倾斜摄影id数组
          }
        }
      });
    },

    addModel(item, type) {
      let data;
      data = mapWorkDyeing.addModel(
        item,
        type,
        (e) => {
          // 处理动态加载逻辑
          item.uid = e.layer.uuid;
          let viewShedItem =
            Object.keys(viewShed).length == 0
              ? undefined
              : viewShed.inquire(
                  "modelArray",
                  "modelId",
                  e.layer.options.modelId
                );
          if (viewShedItem != undefined) {
            viewShedItem.uid = e.layer.uuid;
          } else {
            viewShed.add("modelArray", {
              permission: e.layer.options.permission,
              modelId: e.layer.options.modelId,
              modelType: e.layer.options.modelType,
              url: decodeURI(e.layer.options.url),
              uid: e.layer.uuid,
              center: e.layer._center,
              customize: e.layer.options.customize,
            });
          }

          if (e.layer.options.permission && type == "init") {
            queueMicrotask(() => {
              this.$GLOBAL.map.removeLayer(e.layer.options.id, true);
            });
          }
        },
        (e) => {
          let { layer } = e;
          if (this.$refs.scenerModel) {
            this.setCurrentKey(layer.options.modelId);
          }
          this.postNewTerrainDiggingDat(e);
        }
      );
      return data;
    },
    shutDownLeftDrawer() {
      this.ifLeftFold = true;
    },

    // 获取
    // 场景信息
    getScenarioInformation(item) {
      getBimPlanScenesDetail({ id: item.id })
        .then((res) => {
          console.log("简介", res.data.code);

          if (res.data.code == 200 || res.data.code == 204) {
            if ($(".map-modal-part .el-scrollbar .el-scrollbar__wrap")) {
              $(".map-modal-part .el-scrollbar .el-scrollbar__wrap").scrollTop(
                0
              );
            }
            this.modalNodeScenes.sceneInformationTree.loading = false;
            let {
              id,
              name,
              content,
              isAreaShow,
              areaLocation,
              pId,
              width,
              height,
            } = res.data.data;
            this.submitPartData.id = id;
            this.submitPartData.title = name;
            this.submitPartData.content = content;
            this.submitPartData.isAreaShow = isAreaShow;
            this.submitPartData.areaLocation = areaLocation;
            this.submitPartData.pId = pId.toString();
            this.submitPartData.width = width || "550";
            this.submitPartData.height = height || "400";
            this.stretchModal();
          } else {
            this.$notify({
              title: "获取简介数据失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.modalNodeScenes.sceneInformationTree.loading = false;
          this.$notify({
            title: "获取简介数据失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          // this.$NProgress.done(true);
        });
    },

    // ************************************************ 子场景 ************************************************
    // 添加
    addSubscenes() {},

    // ************************************************ 动画时间轴 ************************************************
    // 初始化时间轴
    initAnimation(data) {
      this.ifAnimation = true;
      this.$refs["animation"].initAnimation(data);
    },
    stretchModal() {
      this.$nextTick((res) => {
        if (this.$refs.MapModalPart) {
          if (this.submitPartData.areaLocation == "middle") {
            this.$refs.MapModalPart.$el.style.marginLeft =
              "-" + this.$refs.MapModalPart.$el.clientWidth / 2 + "px";
            this.$refs.MapModalPart.$el.style.marginTop =
              "-" + this.$refs.MapModalPart.$el.clientHeight / 2 + "px";
          } else {
            this.$refs.MapModalPart.$el.style.marginLeft = "";
            this.$refs.MapModalPart.$el.style.marginTop = "";
          }
        }
      });
    },

    postNewTerrainDiggingDat(e) {
      console.log(e);
      this.newTerrainDiggingData = e.layer.options;
    },
  },
  mounted() {
    this.init();
    window.menuOperate = this.menuOperate;
    try {
      // screenplay.removeKeydown();
      window.screenplay = null;
    } catch (e) {
      console.log("screenplay没有定义"); //sojson is undefined
    }

    let modelData = {
      ProjectId: window.sessionStorage.getItem("nowProjectId"),
      CategoryName: "子分项工程",
    };
    getProjectBimModel(modelData).then((res) => {
      let { dataList } = res.data.data;
      this.$GLOBAL.osgbTilesetLayerIds = [];
      this.recursion(dataList);
      this.$GLOBAL.ptDataList = dataList;
    });
    this.$eventBus.$on("changeStyle", (data) => {
      this.submitPartData.width = parseInt(data.width);
      this.submitPartData.height = parseInt(data.height);
    });

    this.$eventBus.$on("stretchModal", () => {
      this.stretchModal();
    });
  },
  beforeUnmount() {
    graphicLayer.remove(true);
    this.$eventBus.$off("changeStyle");
    this.$eventBus.$off("stretchModal");
    window.removeEventListener("keydown", this.keyDownFn);
  },

  watch: {
    programToggle(newData, oldData) {
      if (newData) {
        // this.init();
      }
    },
    "submitPartData.width"(newData, oldData) {
      this.partStyle.w = newData + "px";
    },
    "submitPartData.height"(newData, oldData) {
      this.partStyle.h = newData + "px";
    },
    "modalIf.sceneInformation"(v) {
      if (!v) {
        this.modalIf.part = false;
        this.$nextTick((res) => {
          this.modalIf.part = true;
        });
      } else {
        this.stretchModal();
      }
    },
    "submitPartData.areaLocation": {
      handler(newName, oldName) {
        this.stretchModal();
      },
      immediate: true,
    },
  },
  destroyed() {
    try {
      // screenplay.removeKeydown();
      window.screenplay = null;
    } catch (e) {
      console.log("screenplay没有定义"); //sojson is undefined
    }

    window.screenplay = null;
  },
};
</script>
<style lang="scss" scoped>
.program-change-information-head {
  position: absolute;
  width: 100%;
  top: 0;
  height: 54px;
  background: #0c121e;
  z-index: 9999;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}
.program-head-enter,
.program-head-leave-to {
  top: -60px;
}
.program-head-enter-active,
.program-head-leave-active {
  transition: all 1s;
}

.program-change-information-left-menu {
  position: absolute;
  left: 0;
  top: 54px;
  width: 252px;
  bottom: 0;
  background: #0c121e;
  z-index: 9999;
  padding-top: 6px;
  transition: all 0.5s;
  /deep/ .el-scrollbar__wrap {
    overflow-x: auto;
  }
  /deep/ .el-collapse {
    border: 0;
    color: #ccc;
    // padding: 0 20px;
    .el-collapse-item {
      padding: 0 20px;
      // border-bottom: 1px solid #ccc;
      &:hover {
        color: #fff;
        background: #1d273b !important;
        .el-collapse-item__header {
          color: #fff;
        }
      }
      &:last-child {
        border-bottom: 0;
      }
      .el-collapse-item__content {
        padding-bottom: 10px;
      }
    }
    .is-active {
      color: #fff;
      background: #1d273b;
      .el-collapse-item__header {
        color: #fff;
      }
    }
    .el-collapse-item__header {
      line-height: initial;
      color: #ccc;
      background-color: transparent;
      border: 0;
      border-bottom: 1px solid #6a6a6a;
    }
    .el-collapse-item__wrap {
      border: 0;
      margin: 0 -20px;
      background: #0c121e;
    }
  }
  .program-add {
    margin-bottom: 10px;
    padding: 0 5px;
  }
  .menu-title-input {
    /deep/ input {
      border: 0;
      background: transparent;
      color: #fff;
      padding: 0;
      font-size: 13px;
    }
  }
}
.program-left-menu-enter,
.program-left-menu-leave-to {
  left: -265px;
}
.program-left-menu-enter-active,
.program-left-menu-leave-active {
  transition: all 1s;
}

.program-left-sceneTree-enter-active,
.program-left-sceneTree-leave-active {
  transition: all 1s ease;
}
.program-left-sceneTree-enter {
  transform: translateX(-100%);
}
.program-left-sceneTree-leave-to {
  transform: translateX(-100%);
}

.sys-area {
  display: flex;
  height: 100%;
  align-items: center;
}
.story-name {
  font-size: 16px;
  color: #ccc;
}
.op-area {
  height: 100%;
  /deep/ .program-el-menu {
    height: 100%;
    border: 0;
    background: transparent !important;
    .el-menu-item {
      background: transparent !important;
      padding: 0;
      border: 0;
      height: 100%;
      line-height: initial;
      width: 80px;
    }
    .el-submenu {
      .el-submenu__title {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        border: 0;
        line-height: initial;
        height: 54px;
        width: 80px;
        .menu-item {
          padding: 0 16px;
          width: 80px;
        }
        &:hover {
          background: #1d273b;
          .menu-item {
            color: #fff;
          }
          i {
            color: #fff;
          }
        }
      }
      .el-submenu__icon-arrow {
        position: absolute;
        right: 2px;
        top: 45%;
      }
    }
    .is-active {
      background: #1d273b !important;
      border: 0 !important;
      .menu-item {
        color: #fff;
      }
      i {
        color: #fff;
      }
    }
  }
}

.tool-library-li {
  padding: 0 !important;
  .menu-item {
    flex-direction: row;
    width: 100%;
    justify-content: left;
    i {
      margin: 0 5px 0 0;
    }
  }
}
.menu-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
  color: #cccccc;
  height: 100%;
  padding: 0 20px;
  cursor: pointer;
  i {
    font-size: 18px;
    margin: 0 0 3px 0;
  }
  i.las {
    font-size: 22px;
    margin: 0;
  }
  i.el-icon-video-play {
    font-size: 20px;
  }
  &:hover {
    color: #fff;
    background: #1d273b;
    i {
      color: #fff;
    }
  }
}
.el-collapse-item__header:hover .program-left-menu-title i {
  opacity: 1;
}
.program-left-menu-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  .operation-view {
    padding: 0 5px;
    display: flex;
    height: 100%;
    align-items: center;
    i {
      color: #ccc;
      padding: 0 5px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      &:hover {
        color: #fff;
      }
      opacity: 0;
    }
  }
}

.program-thumbnail {
  padding: 0;
  list-style-type: none;
  margin-bottom: 0;
  li {
    padding: 5px;
    display: flex;
    align-items: center;
    color: #ccc;
    // height: 82px;
    &.active {
      color: #fff;
      background: #1d273b;
    }
    &.transition {
      height: auto;
      padding: 0;
    }
    &:last-child {
      height: auto;
      padding: 0;
    }
    &:not(:last-child) {
      cursor: pointer;
      &:hover {
        background: #1d273b;
        color: #fff;
      }
    }
    /deep/ img {
      width: 100px;
      max-height: 72px;
      min-height: 30px;
    }
    .program-thumbnail-time {
      height: 100%;
      width: 140px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 30px;
      time {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .program-thumbnail-time-button {
        display: flex;
        justify-content: flex-end;
        padding-right: 5px;
        // display: none;
        i {
          margin: 0 2px;
          color: #ccc;
          font-size: 14px;
          &:hover {
            color: #fff;
          }
        }
      }
      &:hover {
        .program-thumbnail-time-operate {
          opacity: 1;
        }
      }
      .program-thumbnail-time-operate {
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        i {
          font-size: 14px;
          margin: 0 4px;
          color: #ccc;
          &:hover {
            color: #fff;
          }
        }
      }
    }
    .el-tree {
      background: transparent;
      width: 100%;
      color: #ccc;
      /deep/.el-tree-node__content:hover {
        background: transparent;
        color: #fff;
      }
      /deep/.el-tree-node:focus > .el-tree-node__content {
        background: transparent;
      }
    }
  }
  .program-button {
    margin-top: 10px;
  }
}
.program-button {
  background-color: transparent;
  color: #ccc;
  padding: 5px;
  width: 100%;
  border: 1px dashed #ccc;
  &:hover {
    background-color: #fff;
    color: #000;
    border: 1px solid #fff;
  }
  &:active {
    background-color: #fff;
    color: #000;
    border: 1px solid #fff;
  }
  &:focus {
    background-color: #fff;
    color: #000;
    border: 1px solid #fff;
  }
}
/deep/ #introduce {
  z-index: 9999;
  background: rgba(30, 36, 50, 1) !important;
  text-align: center;
  color: #fff;
  .introduce-content {
    padding: 55px 90px;
    h2 {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 60px;
    }
    p {
      font-size: 20px;
      text-align: left;
    }
  }
}

/deep/ .textViewTestP {
  display: none;
}
/deep/ .textViewTest:hover {
  .textViewTestP {
    display: block;
  }
}
.program-thumbnail-add {
  margin: 10px 15px 0 15px;
}

/deep/ .el-collapse-item__arrow {
  order: -1;
}
.el-dropdown {
  color: #ccc;
  font-size: 14px;
}
.if-left-fold .fold-operation {
  transform: rotate(180deg);
}
.fold-operation {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 46px;
  width: 14px;
  // border-width: 1px;
  // border-style: solid;
  box-sizing: border-box;
  padding: 0;
  z-index: 999;
  border-radius: 0 0;
  border-top-right-radius: 3px 3px;
  border-bottom-right-radius: 3px 3px;
  z-index: 2002;
  right: -14px;
  top: 50%;
  background: #0c121e;
  margin-top: -23px;
  cursor: pointer;
  opacity: 0.6;
}
#scenerResourceTree {
  left: -252px;
  transition: all 0.5s;
}
.if-left-fold {
  left: -252px;
  transition: all 0.5s;
}
/deep/ .el-popper {
  min-width: auto;
}
/deep/ #scenerResourceTree {
  transition: all 0.5s;
}
/deep/ #scenerResourceTree {
  left: -252px !important;
}
.if-left-resources.if-left-scenetree /deep/ #scenerResourceTree {
  left: 0 !important;
}
.if-left-scenetree /deep/ #scenerResourceTree {
  left: 252px !important;
}
.tool-library-li {
  .menu-item i {
    margin: 0 10px 0 0;
    font-size: 18px;
  }
}
.transparent_value {
  /deep/.el-form-item {
    margin-bottom: 0px;
    // height: 35px;
    line-height: 35px;
  }
}
.split-l {
  border-left: 1px solid #6a6a6a;
}
/deep/ .laFilterGrey {
  color: rgb(192, 196, 204);
}
/deep/ .laFilterBlue {
  color: rgb(42, 183, 255);
}
.isEditTablist {
  height: calc(100% - 90px) !important;
}
</style>
